export const GBP = (n) =>
  new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" }).format(Number(n || 0));

export const PAYMENT_STATUSES = [
  "UNPAID", "PAID", "PARTIALLY_PAID", "REFUNDED", "CANCELLED", "NOT_REQUIRED",
];
export const PAYMENT_METHODS = [
  "CASH", "CARD_MACHINE", "BANK_TRANSFER", "ONLINE_PAID", "THIRD_PARTY_PAID", "VOUCHER", "OTHER", "UNKNOWN",
];
export const ORDER_STATUSES = [
  "NEW", "ACCEPTED", "PREPARING", "READY", "SERVED", "COMPLETED", "CANCELLED",
  "REJECTED", "NEEDS_REVIEW", "ALLERGY_REVIEW_REQUIRED",
];
export const BOOKING_STATUSES = [
  "CONFIRMED", "PENDING_REVIEW", "ALLERGY_NOTE_REQUIRES_STAFF_REVIEW", "SEATED",
  "COMPLETED", "CANCELLED", "NO_SHOW",
];
export const ALLERGEN_RELATIONS = ["CONTAINS", "MAY_CONTAIN", "CROSS_CONTAMINATION_RISK"];
export const ALLERGEN_STATUSES = ["VERIFIED_BY_RESTAURANT", "NEEDS_REVIEW", "UNKNOWN"];

const label = (s) => (s || "").replace(/_/g, " ").toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
export const pretty = label;

export function statusColor(status) {
  const map = {
    NEW: "bg-blue-50 text-blue-700 border-blue-200",
    ACCEPTED: "bg-blue-50 text-blue-700 border-blue-200",
    PREPARING: "bg-amber-50 text-amber-700 border-amber-200",
    READY: "bg-emerald-50 text-emerald-700 border-emerald-200",
    SERVED: "bg-emerald-50 text-emerald-700 border-emerald-200",
    COMPLETED: "bg-stone-100 text-stone-600 border-stone-200",
    CANCELLED: "bg-stone-100 text-stone-500 border-stone-200",
    REJECTED: "bg-red-50 text-red-700 border-red-200",
    NEEDS_REVIEW: "bg-orange-50 text-orange-700 border-orange-200",
    ALLERGY_REVIEW_REQUIRED: "bg-red-50 text-red-700 border-red-200",
    CONFIRMED: "bg-emerald-50 text-emerald-700 border-emerald-200",
    PENDING_REVIEW: "bg-amber-50 text-amber-700 border-amber-200",
    ALLERGY_NOTE_REQUIRES_STAFF_REVIEW: "bg-red-50 text-red-700 border-red-200",
    SEATED: "bg-blue-50 text-blue-700 border-blue-200",
    NO_SHOW: "bg-stone-100 text-stone-500 border-stone-200",
    PAID: "bg-emerald-50 text-emerald-700 border-emerald-200",
    UNPAID: "bg-red-50 text-red-700 border-red-200",
    PARTIALLY_PAID: "bg-amber-50 text-amber-700 border-amber-200",
    REFUNDED: "bg-purple-50 text-purple-700 border-purple-200",
    NOT_REQUIRED: "bg-stone-100 text-stone-500 border-stone-200",
    AVAILABLE: "bg-emerald-50 text-emerald-700 border-emerald-200",
    OCCUPIED: "bg-accent/15 text-accent border-accent/30",
    RESERVED: "bg-amber-50 text-amber-700 border-amber-200",
    NEEDS_CLEANING: "bg-stone-100 text-stone-500 border-stone-200",
  };
  return map[status] || "bg-stone-100 text-stone-600 border-stone-200";
}
